import { render } from "./PageControl.vue?vue&type=template&id=66f07fbf"
import script from "./PageControl.vue?vue&type=script&lang=js"
export * from "./PageControl.vue?vue&type=script&lang=js"

import "./PageControl.vue?vue&type=style&index=0&id=66f07fbf&lang=scss"
script.render = render

export default script